module.exports = __webpack_public_path__ + "media/8min.d234eceb.mp4";